import React from "react"

import { FieldErrors, UseFormRegister, UseFormWatch } from "react-hook-form"

import styles from "./BuldApplyForm.module.scss"
import { AUTO_CLAIM_BASE_LABEL } from "./labelMaps"

import { CompanySmsSendingRuleAutoClaimBase } from "@/souhl_admin/gql/__generated__/graphql"
import { SmsSendingStartSettingsForm } from "@/souhl_admin/utils/form/smsSendingStartSettings"

type BulkApplyFormProps = {
	register: UseFormRegister<SmsSendingStartSettingsForm>
	watch: UseFormWatch<SmsSendingStartSettingsForm>
	errors?: FieldErrors<SmsSendingStartSettingsForm>
	rightControls?: React.ReactNode
}

const BulkApplyForm: React.FC<BulkApplyFormProps> = ({
	register,
	watch,
	errors = {},
	rightControls,
}) => {
	const enableAutoClaimStartDate = watch("enableAutoClaimStartDate") || false
	const enableEncourageStartCancelDate =
		watch("enableEncourageStartCancelDate") || false
	return (
		<div className={styles.section}>
			<div className={styles.row}>
				<label>
					<span className={styles.label}>自動請求開始基準:</span>
					<select className={styles.select} {...register("autoClaimBase")}>
						<option
							value={"CANCEL_DATE" satisfies CompanySmsSendingRuleAutoClaimBase}
						>
							{AUTO_CLAIM_BASE_LABEL.CANCEL_DATE}
						</option>
						<option
							value={
								"RESERVATION_RECEIPTED_DATE" satisfies CompanySmsSendingRuleAutoClaimBase
							}
						>
							{AUTO_CLAIM_BASE_LABEL.RESERVATION_RECEIPTED_DATE}
						</option>
					</select>
				</label>
				{errors.autoClaimBase?.message && (
					<span className={styles.error}>{errors.autoClaimBase.message}</span>
				)}

				<div className={styles.date_form_container}>
					<label className={styles.checkbox_label}>
						<input type="checkbox" {...register("enableAutoClaimStartDate")} />
						<span>自動請求を開始する</span>
					</label>
					{enableAutoClaimStartDate && (
						<label>
							<span className={styles.label}>自動請求開始日:</span>
							<input
								className={styles.input}
								type="date"
								{...register("autoClaimStartDate")}
							/>
						</label>
					)}
					{errors.autoClaimStartDate?.message && (
						<span className={styles.error}>
							{errors.autoClaimStartDate.message}
						</span>
					)}
				</div>

				<div className={styles.date_form_container}>
					<label className={styles.checkbox_label}>
						<input
							type="checkbox"
							{...register("enableEncourageStartCancelDate")}
						/>
						<span>再予約案内を開始する</span>
					</label>
					{enableEncourageStartCancelDate && (
						<label>
							<span className={styles.label}>再予約案内開始日:</span>
							<input
								className={styles.input}
								type="date"
								disabled={!enableEncourageStartCancelDate}
								{...register("encourageStartCancelDate")}
							/>
						</label>
					)}
					{errors.encourageStartCancelDate?.message && (
						<span className={styles.error}>
							{errors.encourageStartCancelDate.message}
						</span>
					)}
				</div>
				{rightControls && (
					<div className={styles.right_controls}>{rightControls}</div>
				)}
			</div>
		</div>
	)
}

export default BulkApplyForm
